// extracted by mini-css-extract-plugin
module.exports = {"number":"Odds-module--number--2W54P","extraNumber":"Odds-module--extraNumber--3A7Ds"};